// extracted by mini-css-extract-plugin
export default {"balance-popover-content":"balance-popover-content--VolpS","balancePopoverContent":"balance-popover-content--VolpS"};